function toggleHeaderTransparency() {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  const isHome = window.location.pathname === '/' || window.location.pathname.includes('?pb=0');
  const atTop = window.scrollY === 0;

  if (isHome && atTop) {
    header.classList.add('header--transparent');
  } else {
    header.classList.remove('header--transparent');
  }
}

window.addEventListener('scroll', toggleHeaderTransparency);
window.addEventListener('load', toggleHeaderTransparency);
document.addEventListener('DOMContentLoaded', toggleHeaderTransparency);

// Detectar navegación interna en Shopify
let lastPath = window.location.pathname;
setInterval(() => {
  if (window.location.pathname !== lastPath) {
    lastPath = window.location.pathname;
    toggleHeaderTransparency();
  }
}, 500);
